<div class="recent-project-trends">
  <div class="mat-subheading-2" fxLayout fxLayoutGap="4px" fxLayoutAlign="start cetner">
    <mat-icon>queue_music</mat-icon>
    <div>
      <span>直近 5 作品動向</span>
      <span class="date-range">
        リリースから {{ today | date: 'yyyy-MM-dd' }} までの集計データ
      </span>
      @if (selectedArtist$ | async; as artist) {
        <a
          href="https://consumption.umusic.com/artist/{{
            artist.globalId
          }}?territory=JP&area=Country"
          target="_blank"
          class="date-range"
          >
          <span>Consumptionで詳細を見る</span>
          <img src="./assets/outside_link.png" class="icon" />
        </a>
      }
    </div>
    <mat-icon
      class="help"
      matTooltip='フィジカル売上枚数（NET）、ストリーム数、アルバムダウンロード数、トラックダウンロード数はリリース日からの合計数です。
      アルバム換算数は、フィジカル・ストリーム・ダウンロードのアルバム換算数の合計です。
      作品は、UM Consumptionの"Project" に該当します。"Project"には、アルバム・シングル・maxiなどが含まれますが、"Project"の作られ方により表示されるべきものが異なる場合があります。ご要望・不明点あれば、画面上部のアドレスより、ご連絡ください。'
      >help_outline</mat-icon
      ><app-csv-download
      [id]="csvId"
      [fileName]="csvFileName"
      [csv]="csvData$ | async"
      [loading]="loading$ | async"
      [artist]="selectedArtist$ | async"
    ></app-csv-download>
  </div>
  <div fxLayout="column" fxLayoutGap="8px">
    @for (sale of projectSales$ | async; track sale) {
      <div>
        <app-project-sale [projectSale]="sale" [loading]="loading$ | async"></app-project-sale>
      </div>
    }
  </div>
</div>
